import React from "react";

const BackofficePage = () => {
  return (
    <div className="container mt-4">
      <h2>Backoffice</h2>
      <p>Incoming Orders</p>
    </div>
  );
};

export default BackofficePage;